// Called by :  src/components/misc/ModalAbout.vue
//              src/components/misc/ModalCgu.vue
//              src/components/question/AnswerMcq.vue
//              src/components/question/BaseModal.vue
//              src/components/question/AnswerScq.vue
//              src/components/question/AnswerUpload.vue

<template>
  <transition name="modal">
    <div v-bind:id="pageId" class="modal fade " v-bind:class="pageClass" tabindex="-1" role="dialog" v-bind:aria-labelledby="pageId" aria-hidden="true" v-bind:data-backdrop="modalDataBack" v-bind:data-keyboard="modalDataKey">
      <div class="modal-dialog modal-dialog-centered " v-bind:class="modalClass" role="document">
        <div class="modal-content">

          <div class="modal-header px-lg-4 px-md-3 px-sm-2">
              <slot name="header">
                <h3>{{ $t('answer.title') }}</h3>
              </slot>
          </div> <!-- .modal-header -->

          <div class="modal-body px-lg-5 px-md-4 px-sm-3">
            <slot name="body">
            </slot>
          </div> <!-- .modal-body -->

          <div class="modal-footer px-lg-4 px-md-3 px-sm-2">
            <slot name="footer">
            </slot>
          </div> <!-- .modal-footer -->

        </div> <!-- .modal-content -->
      </div> <!-- .modal-dialog -->

      {{ forceUpdate }} 

    </div> <!-- .modal -->
  </transition>
</template>

<script>
export default {
  props: {
    pageId: String,
    pageClass: String,
    modalClass: String,
    modalDataBack: String,
    modalDataKey: String,
  },
  methods: {
    getKey() {
      return 'Modal' + f_getRandomMinMax_n(100000000, 999999999);
    },
  },
  computed: {
    forceUpdate() {
      return '';
    },
  },
}
</script>

<style scoped>
  /* void */
</style>



// WEBPACK FOOTER //
// src/components/BaseModal.vue